/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './CServiceCoverageSummary.scss'
import { Collapse, CardBody, Card, CardHeader, Container } from 'reactstrap'
import { ServiceTypeHelper } from '../../../../utils/ServiceTypeHelper'
import { ICoverageDiscoveryResponseStateManager } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface ICServiceCoverageSummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

interface ICServiceCoverageSummaryState {
	collapse: number
}

export class CServiceCoverageSummaryComponent extends React.Component<ICServiceCoverageSummaryProps, ICServiceCoverageSummaryState> {
	constructor(props: Readonly<ICServiceCoverageSummaryProps>) {
		super(props)
		this.toggle = this.toggle.bind(this)
		this.state = { collapse: 0 }
	}

	toggle(e: React.MouseEvent<HTMLElement, MouseEvent>): void {
		const event = e.currentTarget.dataset.event
		this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) })
	}

	render(): React.ReactNode {
		const serviceCoverageSection = this.props.CoverageDiscoveryResponseStateManager.selectedServiceCoverageSection
		const { collapse } = this.state
		if (typeof serviceCoverageSection !== 'undefined') {
			return (
				<div className="accordion-group service-coverage">
					<div id={serviceCoverageSection.id} className="section" data-loadorder={serviceCoverageSection.loadOrder} data-index={serviceCoverageSection.summary.index}>
						<Card style={{ marginBottom: '1rem' }} className="card" key={serviceCoverageSection.displayOrder}>
							<CardHeader onClick={this.toggle} data-event={serviceCoverageSection.displayOrder} className="service-coverage accordion-heading whiteText">
								{serviceCoverageSection.summary.title}
							</CardHeader>
							<Collapse isOpen={collapse === serviceCoverageSection.displayOrder}>
								<CardBody className="card-body">
									<Container style={{ margin: 0, padding: 0, width: '100%' }}>
										<table className="service-types-table">
											<tbody>
												<tr className="summaryDisplaying">
													<td colSpan={4}>
														Displaying {serviceCoverageSection.summary.selectedSections.length} of {serviceCoverageSection.summary.sections.length} sections
													</td>
												</tr>
											</tbody>

											{ServiceTypeHelper.getCommercialSTC(serviceCoverageSection).map((res, index) => {
												return (
													<tbody className="summaryBody" key={index}>
														<tr className="summarySection">
															<td colSpan={2}>
																<h4>
																	{res.serviceCodeDescription}&nbsp;({res.serviceCode})
																</h4>
															</td>
															<td className="active">
																<strong>{res.status}</strong>
															</td>
															<td className="summaryDetails">
																<input type="hidden" value={res.serviceCode} />
															</td>
														</tr>
													</tbody>
												)
											})}
										</table>
									</Container>
								</CardBody>
							</Collapse>
						</Card>
					</div>
				</div>
			)
		} else {
			return <></>
		}
	}
}
